const curriculumOrder = { "Sound Beginnings": 0, "Let's Play Music": 1, Presto: 2 };
const sortByCurriculum = (a, b) => (curriculumOrder[a] < curriculumOrder[b] ? -1 : 1);
export default sortByCurriculum;
